import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

// Get saved language from localStorage or default to Arabic
const savedLanguage = localStorage.getItem('i18nextLng') || 'ar';

// Set document direction based on language
// Both Arabic and English use RTL direction
const setDocumentDirection = (lang) => {
  if (typeof document !== 'undefined') {
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.body.dir = dir;
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;

    // Switch Bootstrap CSS
    const bootstrapLink = document.getElementById('bootstrap-css');
    if (bootstrapLink) {
      const newHref = lang === 'ar' 
        ? '/assets/css/bootstrap.rtl.min.css' 
        : '/assets/css/bootstrap.min.css';
      
      if (bootstrapLink.getAttribute('href') !== newHref) {
        bootstrapLink.href = newHref;
      }
    }
  }
};

// Set initial direction
setDocumentDirection(savedLanguage);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      ar: {
        translation: arTranslations
      }
    },
    lng: savedLanguage, // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes values
    },
    react: {
      useSuspense: false
    }
  });

// Listen to language changes and update direction
i18n.on('languageChanged', (lng) => {
  setDocumentDirection(lng);
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;

